import type { ReactNode } from 'react';

import { ChevronRight } from 'lucide-react';

/**
 * Static label/value row in the channel-info card (no icon, non-navigating) —
 * used for "Channel Type" / "Required Subscription".
 */
export function ChannelInfoRow({
  icon,
  label,
  right,
}: {
  icon?: ReactNode;
  label: string;
  right: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3 px-3 py-2.5">
      <div className="text-content-1 flex items-center gap-2 text-sm">
        {icon}
        {label}
      </div>
      <div className="flex items-center gap-1">{right}</div>
    </div>
  );
}

/** Right-aligned count on a nav row; hidden when zero (matches upstream). */
export function RowCount({ value }: { value: number }) {
  if (value <= 0) return null;
  return <span className="text-content-2 text-sm tabular-nums">{value}</span>;
}

/**
 * Tappable channel-info nav row — icon + label + optional right count + a
 * trailing chevron. Opens a sub-pane (Members / Bookmarks / Reports).
 */
export function ChannelInfoRowButton({
  icon,
  label,
  right,
  onClick,
}: {
  icon?: ReactNode;
  label: string;
  right: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="hover:bg-surface-1 flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition"
    >
      <div className="text-content-1 flex items-center gap-2 text-sm">
        {icon}
        {label}
      </div>
      <div className="flex items-center gap-1">
        {right}
        <ChevronRight className="text-content-4 h-4 w-4" aria-hidden />
      </div>
    </button>
  );
}
